import publicRuntimeConfig from "@FRAMEWORK/config/public";
import useConfigureAxios from "@FRAMEWORK/utils/useConfigureAxios";
import {Response} from "@QUERIES/types";
import {UseQueryOptions, useQuery} from "@tanstack/react-query";

interface AttachType {
	reviewId: number;
	attaFileKey: string;
	attaFileSeqNo: number;
	sevSaveDirNm: string;
	sevSaveFileNm: string;
	vimeoEndPoint: string;
}

interface ReviewType {
	reviewId: number;
	webCustNo: string;
	custNm: string;
	reviewDt: string;
	resvNo: string;
	goodsCd: string;
	companion: string;
	companionNm: string;
	companionAttr1: string;
	age: string;
	ageNm: string;
	score: number;
	detail: string;
	attaFileKey: string;
	likeCnt: number;
	keywords: string;
	reportYn: "Y" | "N";
}

interface ReviewDataType {
	reviewList: ReviewType[];
	attachList: AttachType[];
}

/** ```
 * 이용 약관 조회
 *   `/portal/product/${goodsCd}/review`
 * parameter
 *   `goodsCd` 상품코드
 * ```*/
const key = `useReview`;
const getPath = (goodsCd?: string): string | null => {
	if (!goodsCd) return "";
	return `${publicRuntimeConfig.ENV_PORTAL_API_URL}/portal/product/${goodsCd}/review`;
};

/** ```
 * 이용 약관 조회
 *   `/portal/product/${goodsCd}/review`
 * parameter
 *   `goodsCd` 상품코드
 * ```*/
const useReview = (goodsCd?: string, options?: Partial<UseQueryOptions<Response<ReviewDataType>, Error>>) =>
	useQuery({
		queryKey: [key, getPath(goodsCd)],
		queryFn: () => useConfigureAxios({url: getPath(goodsCd)}).then(r => r.data),
		gcTime: Infinity,
		staleTime: Infinity,
		throwOnError: false,
		...options,
	});

export default useReview;
export {getPath, key};
export type {ReviewDataType, AttachType, ReviewType};
